import PropTypes from 'prop-types'
import classNames from 'classnames'
import Center from 'components/Center'
import Loading from 'components/loading/Loading'
import { Link } from 'react-router-dom'
import { forwardRef } from 'react'

const SIZE = {
  big: 'gb',
  medium: 'gm',
  small: 'gs',
}

const Button = forwardRef(
  (
    {
      tag: Tag = 'button',
      className = '',
      type = 'button',
      size = 'medium',
      icon = false,
      primary = false,
      dark = false,
      line = false,
      round = false,
      disabled = false,
      loading = false,
      style = {},
      linkTo = null,
      linkReplace = false,
      children = '확인',
      ...rest
    },
    ref
  ) => {
    const content = (
      <Center.Container tag="div">
        <span
          className={classNames('inner_g', { icon_g: icon })}
          style={loading ? { visibility: 'hidden' } : {}}>
          {children}
        </span>
        {loading && (
          <Center>
            <Loading
              size="icon"
              {...(primary
                ? { color: 'white' }
                : disabled
                ? { color: '#ccc' }
                : {})}
            />
          </Center>
        )}
      </Center.Container>
    )

    const applyingClassName =
      className ||
      classNames(`btn_${SIZE[size]}`, {
        [`${SIZE[size]}_line`]: line,
        [`${SIZE[size]}_bl`]: primary,
        [`${SIZE[size]}_bk`]: dark,
        [`${SIZE[size]}_round`]: round,
        in_active: disabled,
      })

    const applyingStyle = {
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      MsUserSelect: 'none',
      userSelect: 'none',
      ...(loading ? { pointerEvents: 'none' } : {}),
      ...style,
    }
    return linkTo ? (
      <Link
        to={linkTo}
        replace={linkReplace}
        ref={ref}
        className={applyingClassName}
        style={applyingStyle}
        {...rest}>
        {content}
      </Link>
    ) : (
      <Tag
        type={type}
        ref={ref}
        className={applyingClassName}
        style={applyingStyle}
        {...rest}>
        {content}
      </Tag>
    )
  }
)

Button.displayName = 'Button'
Button.propTypes = {
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  children: PropTypes.node,
  tag: PropTypes.string,
  linkTo: PropTypes.string,
  linkReplace: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf(['big', 'medium', 'small']),
  icon: PropTypes.bool,
  dark: PropTypes.bool,
  primary: PropTypes.bool,
  line: PropTypes.bool,
  round: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  style: PropTypes.object,
  onClick: PropTypes.func,
}

export default Button
